import React, { useState } from 'react';
import { signInWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getDoc, doc } from 'firebase/firestore';
import { useNavigate, useLocation } from 'react-router-dom';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { auth, db } from '../../server/firebase';
import './LoginAdministrativos.css';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 Ruta original (si viene de ProtectedRoute)
  const from = location.state?.from?.pathname;

  // 🔥 Función para decidir ruta por defecto según rol
  const getDefaultRoute = (role) => {
    if (role === "ADMINISTRADORES") return "/administrativos";
    return "/miplataforma";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    console.log("LOCATION STATE:", location.state);

    // Validaciones
    if (!email || !password) {
      setError('Por favor completa todos los campos');
      setLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Por favor ingresa un email válido');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      await setPersistence(auth, browserLocalPersistence);

      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 🔎 Obtener rol desde Firestore
      let roleFound = 'ASESOR';

      const adminDocRef = doc(db, 'ADMINISTRADORES', 'ADMINISTRADORES');
      const adminDocSnap = await getDoc(adminDocRef);

      if (adminDocSnap.exists()) {
        const data = adminDocSnap.data();
        if (data && data[user.email]) {
          roleFound = 'ADMINISTRADORES';
        }
      }

      // Guardar en localStorage
      localStorage.setItem('userEmail', user.email);
      localStorage.setItem('userRole', roleFound);

      // Actualizar estado global
      onLogin(user.email, roleFound);

      // 🚀 REDIRECCIÓN INTELIGENTE
      const redirectTo = from || getDefaultRoute(roleFound);
      navigate(redirectTo, { replace: true });

    } catch (err) {
      console.error('Error:', err);

      if (err.code === 'auth/user-not-found') {
        setError('Usuario no encontrado');
      } else if (err.code === 'auth/wrong-password') {
        setError('Contraseña incorrecta');
      } else if (err.code === 'auth/invalid-email') {
        setError('Email inválido');
      } else {
        setError('Error al iniciar sesión: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="administrativos-login-container">
      <div className="administrativos-login-box">
        <h1>Iniciar Sesión</h1>

        <form onSubmit={handleSubmit}>
          <div className="administrativos-form-group">
            <label htmlFor="email" className="administrativos-label">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
            />
          </div>

          <div className="administrativos-form-group">
            <label htmlFor="password" className="administrativos-label">Contraseña</label>
            <div className="administrativos-password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
              />
              <button
                type="button"
                className="administrativos-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <AiOutlineEye className="administrativos-toggle-icon" />
                ) : (
                  <AiOutlineEyeInvisible className="administrativos-toggle-icon" />
                )}
              </button>
            </div>
          </div>

          {error && <div className="administrativos-error-message">{error}</div>}

          <button type="submit" className="administrativos-btn-login" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        
      </div>
    </div>
  );
}

export default Login;